export const AMOUNT_PATTERN = /^\d+((\.|,)\d{1,2})?$/;
export const AMOUNT_RUNTIME_PATTERN = /^\d*((\.|,)\d{0,2})?$/;

export const validateAmount = (value: string) => {
  const parsedValue = Number(value);
  const isNaN = parsedValue !== parsedValue;

  return !!value && !isNaN && AMOUNT_PATTERN.test(`${parsedValue}`);
};

export const validateAmountRuntime = (value: string) =>
  AMOUNT_RUNTIME_PATTERN.test(value);
